// utils/recouvrementDisponible.js
// ============================================================================
// L'ONGLET RECOUVREMENT EXISTE-T-IL ? — CONNU AVANT D'ENTRER DANS LE MODULE
// ============================================================================
// L'onglet Recouvrement de « Comptabilité & Paie » n'existe que si l'école a une
// année clôturée (est_cloturee = 1, est_active = 0 : même règle que
// `RecouvrementService.estDisponible` côté serveur).
//
// Demander au serveur à chaque entrée dans le module faisait apparaître
// l'onglet après coup, à chaque passage. La réponse ne change qu'à une clôture :
// elle est donc notée dans le navigateur dès la connexion (la page de connexion
// reçoit la liste des années), lue au premier affichage du module, puis
// revérifiée en arrière-plan. Le stockage est propre au sous-domaine, donc à
// l'école.
// ============================================================================

const CLE = 'klasys_recouvrement_disponible';

/** true / false si la réponse est connue, null sinon. */
export const lireRecouvrementDisponible = () => {
  try {
    const valeur = localStorage.getItem(CLE);
    if (valeur === 'true') return true;
    if (valeur === 'false') return false;
  } catch {
    // Stockage verrouillé : on attendra la réponse du serveur.
  }
  return null;
};

export const noterRecouvrementDisponible = (disponible) => {
  try {
    localStorage.setItem(CLE, disponible ? 'true' : 'false');
  } catch {
    // Sans stockage, l'onglet arrivera simplement avec la réponse du serveur.
  }
};

/** Depuis la liste des années (page de connexion). */
export const recouvrementDisponibleDepuisAnnees = (annees = []) => (
  Array.isArray(annees)
  && annees.some((a) => Number(a.est_cloturee) === 1 && Number(a.est_active) !== 1)
);
